export class ChainedDocumentIdentifier {
  constructor(public id: number, public edition: number) {
  }

  clone(): ChainedDocumentIdentifier {
    return new ChainedDocumentIdentifier(this.id, this.edition);
  }
}
